import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { ClassroomService } from '../../../../core/services/classroom.service';
import { ProfessorAcademicClassroomService } from '../../../../core/services/professor-academic-classroom.service';
import { StudentAyClassroomService } from '../../../../core/services/student-ay-classroom.service';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../../admin/layout/includes/header/header.component';
import { ProfessorListComponent } from '../../../components/professor-list/professor-list.component';

@Component({
    selector: 'app-classroom-professor-list',
    templateUrl: './classroom-professor-list.component.html',
    imports: [
        ProfessorListComponent,
        CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule
    ],
    styleUrls: ['./classroom-professor-list.component.css']
})
export class ClassroomProfessorListComponent {
  vue="list"

  classroomId:any
  buttonsPermission :any|undefined;
 search_text=""
  classrooms:any[] =[]
  roles:any[] =[]
  data:any[] =[]
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  tag="professors-classroom-professors-list"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any


  constructor(
    private classroomService:ClassroomService,
    private sacService:StudentAyClassroomService,
    private pacService:ProfessorAcademicClassroomService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
    this.getActions()
  }

  init(){
    this.getClassrooms()
  }


  getClassrooms(){
    this.classroomService.getAll().subscribe((res:any)=>{
      this.classrooms=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des classes enseignants",err)
    })
  }

  getClassroomProfessorList(){
    this.classroomService.getClassroomProfessorList(this.classroomId).subscribe((res:any)=>{
      this.data=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des classes enseignants",err)
    })
  }

  loadlist(e:any){
    this.classroomId=e.target.value;
    this.getClassroomProfessorList()
  }


  store(value:any){
    this.loading=true
    
    this.sacService.store(value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des permissions",err)

    })
  }
  update(value:any){
    this.loading=true

    this.sacService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des permissions",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.sacService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des permissions",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.sacService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des permissions",err)

      })
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }



  changeView(event:any){
    this.vue=event.target.value
  }

}
